import * as React from "react";
import {Spin} from "antd";

export default () => <Spin tip="Loading..." spinning={true}>
  <div style={{height: '300px'}} />
</Spin>